import { DeltaTrend } from "@/Utils/tableColumns/functions";

import { GetCustomersResponse } from "server/dwhApi/customers/models.js";
import { GetAccessCodesResponse } from "server/scannerApi/customers/models.js";

export const mixedWastePerformance = (
  currentPeriod: GetCustomersResponse,
  firstPeriod: GetCustomersResponse,
  accessCodes?: GetAccessCodesResponse,
) =>
  currentPeriod.customers.map((t) => {
    const tenantLastPeriod = firstPeriod.customers.find(
      (el) => el.customerName === t.customerName,
    );
    const previousAmount =
      tenantLastPeriod?.totalResidualWasteWeight.quantity ?? 0;
    const diff = t.totalResidualWasteWeight.quantity - previousAmount;
    const trend =
      diff < 0
        ? DeltaTrend.Positive
        : diff === 0
          ? DeltaTrend.Neutral
          : DeltaTrend.Negative;

    const tenantCode =
      accessCodes?.data?.find((el) => el.storeUuid === t.customerId)
        ?.accessCode || "";

    return {
      id: t.customerName,
      name: t.customerName,
      rate: t.totalResidualWasteWeight.quantity,
      diff,
      unit: t.totalResidualWasteWeight.unit,
      trend,
      tenantCode,
    };
  });

export const percentagePerformance = (
  currentPeriod: GetCustomersResponse,
  firstPeriod: GetCustomersResponse,
  accessCodes?: GetAccessCodesResponse,
) =>
  currentPeriod.customers.map((t) => {
    const tenantLastPeriod = firstPeriod.customers.find(
      (el) => el.customerName === t.customerName,
    );
    const previousAmount = (tenantLastPeriod?.sortingDegree ?? 0) * 100;
    const currentSortingDegree = t.sortingDegree * 100;
    const diff = currentSortingDegree - previousAmount;
    const trend =
      diff < 0
        ? DeltaTrend.Negative
        : diff === 0
          ? DeltaTrend.Neutral
          : DeltaTrend.Positive;

    const tenantCode =
      accessCodes?.data?.find((el) => el.storeUuid === t.customerId)
        ?.accessCode || "";

    return {
      id: t.customerName,
      name: t.customerName,
      rate: t.sortingDegree * 100,
      diff,
      unit: "percent",
      trend,
      tenantCode,
    };
  });
